import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    attachChildTableTitle: 'Список заявок на привязку ребенка к родителю',
    attachChildAttachButton: 'Подать заявку',
    attachChild_importFiles: 'Загрузить файлы',
    attachChild_fillIin: 'Введите ИИН ребенка',
    attachChild_chooseParentStatus: 'Кем вы приходитесь ребенку?',
    attachChild_parentStatus_MOTHER: 'Мать',
    attachChild_parentStatus_FATHER: 'Отец',

    //column
    attachChildColumn_request: '№ - номер заявки',
    attachChildColumn_requesterFullName: 'Фио заявителя',
    attachChildColumn_childIin: 'ИИН ребенка',
    attachChildColumn_requesterIin: 'ИИН заявителя',
    attachChildColumn_status: 'Статус заявки',
    attachChildColumn_date: 'Дата подачи заявки',
    attachChildColumn_status_NEW: 'Новый',
    attachChildColumn_status_DECLINED: 'Отклонен',
    attachChildColumn_status_APPROVED: 'Принят',
    attachChildColumn_parentStatus: 'Статус родителя',
    attachChildColumn_reason: 'Причина отказа',
    attachChildColumn_attachFile: 'Прикрепленные документы:',

    //modal
    attachChild_attachChild: 'Заявка на привязку ребенка к родителю',
    attachChildModal_applicationMatchChild: 'Заявка на привязку ребенка к родителю',
    attachChildModal_attachFileDescription:
      'Пожалуйста, приложите сканированные версии или цифровые копии хотя бы одного из следующих документов для ребенка под опекой:',
    attachChildModal_attachFileDescriptionFirstItem: 'Свидетельство о рождении',
    attachChildModal_attachFileDescriptionSecondItem: 'Документ, удостоверяющий личность',
    attachChildModal_attachFileDescriptionThirdItem: 'Решение об установлении опеки',
    attachChildModal_apply: 'Подать',
    attachChildModal_close: 'Закрыть',

    //errors
    attachChild_noIin: 'Пожалуйста, введите ИИН ребенка',
    attachChild_badInputIin: 'ИИН должен состоять из 12 цифр',
    attachChild_noFile: 'Пожалуйста, загрузите хотя бы один файл',
    attachChildDucks_makeApplicationFailed: 'Не удалось подать заявку',
    attachChildDucks_loadRequesterFailed: 'Не удалось загрузить список заявок',
    attachChild_noParentStatus: 'Пожалуйста, выберите статус родителя'
  },
  kk: {
    attachChildTableTitle: 'Бала мен ата-ананы байланыстыру өтініштерінің тізімі',
    attachChildAttachButton: 'Өтініш беру',
    attachChild_importFiles: 'Файлдарды жүктеу',
    attachChild_fillIin: 'Баланың ЖСН енгізіңіз',
    attachChild_chooseParentStatus: 'Сіз балаға кім боласыз?',
    attachChild_parentStatus_MOTHER: 'Анасы',
    attachChild_parentStatus_FATHER: 'Әкесі',

    // column
    attachChild_attachChild: 'Баланың ата-анаға байланысына өтінім',
    attachChildColumn_request: '№ - өтінімнің нөмірі',
    attachChildColumn_requesterFullName: 'Өтініш берушінің ТАӘ',
    attachChildColumn_childIin: 'Баланың ЖСН-і',
    attachChildColumn_requesterIin: 'Өтініш берушінің ЖСН-і',
    attachChildColumn_status: 'Өтініш статусы',
    attachChildColumn_date: 'Өтініш күні',
    attachChildColumn_status_NEW: 'Жаңа',
    attachChildColumn_status_DECLINED: 'Қабылданбады',
    attachChildColumn_status_APPROVED: 'Қабылданды',
    attachChildColumn_parentStatus: 'Ата-ана статусы',
    attachChildColumn_reason: 'Кері қайтару себебі',
    attachChildColumn_attachFile: 'Қосылған құжаттар:',

    // modal
    attachChildModal_applicationMatchChild: 'Баланы ата-анаға байланыстыру өтініші',
    attachChildModal_attachFileDescription:
      'Келесі құжаттардың кемінде біреуінің сканерленген немесе сандық көшірмесін тіркеңіз қамқорлықтағы бала үшін:',
    attachChildModal_attachFileDescriptionFirstItem: 'Туу туралы куәлік',
    attachChildModal_attachFileDescriptionSecondItem: 'Жеке куәлік немесе төлқұжат',
    attachChildModal_attachFileDescriptionThirdItem: 'Қамқоршылық туралы шешім',
    attachChildModal_apply: 'Өтініш беру',
    attachChildModal_close: 'Жабу',

    // errors
    attachChild_noIin: 'Бала ЖСН енгізіңіз',
    attachChild_badInputIin: 'ЖСН 12 саннан тұруы керек',
    attachChild_noFile: 'Кемінде бір файл жүктеу қажет',
    attachChildDucks_makeApplicationFailed: 'Өтініш жіберілмеді',
    attachChildDucks_loadRequesterFailed: 'Өтініштер тізімін жүктеу сәтсіз аяқталды',
    attachChild_noParentStatus: 'Ата-ананың мәртебесін таңдаңыз'
  }
});
